<div class="preloader">
    <div class="preloader-spin"></div>
</div>
